// This file was generated by lezer-generator. You probably shouldn't edit it.
export const Program = 1,
  Statement = 2,
  Variable = 3,
  StringType = 4,
  BooleanType = 5,
  NumberType = 6,
  UnitDiv = 7,
  AtomicUnit = 8,
  UnitMul = 9,
  UnitPow = 10,
  NonNegativeInteger = 11,
  DateType = 12,
  DatetimeType = 13,
  NullableStringType = 14,
  NullableNumberType = 15,
  NullableBooleanType = 16,
  NullableDateType = 17,
  NullableDatetimeType = 18,
  Boolean = 19,
  Number = 20,
  String = 21,
  Unary = 22,
  Binary = 24,
  CompareOp = 25,
  FunctionCall = 28,
  FunctionName = 29,
  FunctionArg = 30,
  FunctionMatchArg = 31,
  FunctionMatchKind = 32,
  Null = 33,
  Expression = 34,
  Unit = 35;
